<div class="no-url-container fiber-bg-blue-primary fiber-p-5 fiber-ta-center">
  <h2 class="fiber-text fiber-text--size-2 fiber-text--color-white">No URL Found</h2>
  <p class="fiber-text fiber-text--size-1 fiber-text--color-white">The requested redirect URL was not found or is missing.</p>
  <button class="btn btn-primary mt-3" routerLink="/employer/login">Return to Login</button>
</div>
